
export default {
  // Airport details
  "rank": "排名",
  "hand_check_rate": "人工检查率",
  "reviews": "评论",
  "loading_airport": "加载机场详情中...",
  "airport_not_found": "未找到机场",
  "airport_reviews": "机场评论",
  "no_reviews_yet_share": "暂无评论",
  "share_film_community": "与胶片社区分享您的体验！",
  "add_review_button": "添加评论",
  "back_to_lenses": "返回镜头列表",
  "back_to_cameras": "返回相机列表",
  "failed_load_lens": "加载镜头详情失败",
  "lens_not_found": "未找到镜头",
  "favorite_airports": "收藏的机场",
  "no_favorite_airports": "暂无收藏的机场",
  "user_favorites": "用户收藏",
  "manage_favorites": "管理收藏",
  "remove_from_favorites": "从收藏中移除",
  "add_to_favorites": "添加到收藏",
  "airport_added_favorites": "机场已添加到收藏",
  "airport_removed_favorites": "机场已从收藏中移除",
};
